<div class="drawer-content-screen">
  @if (cannotLoadAvailableOrganizationUsers) {
    <div class="flex-col-center">
      <app-something-went-wrong
        description="{{ 'cannotLoadOrgUsers' | translate }}"
        [showPicture]="false"
        (retryEmitter)="
          loadAvailableOrganizationUsers()
        "></app-something-went-wrong>
    </div>
  }

  @if (availableOrganizationUsersIsLoading) {
    <div class="h-full">
      <app-skeleton-form-drawer></app-skeleton-form-drawer>
    </div>
  }

  @if (
    !cannotLoadAvailableOrganizationUsers &&
    !availableOrganizationUsersIsLoading &&
    isUploaded
  ) {
    <div class="drawer-content-screen__title">
      {{
        userMailAccount
          ? ('changeUserRole' | translate)
          : ('addUserToMailAccount' | translate)
      }}
    </div>
    <div class="drawer-content-screen__body">
      <form
        class="flex w-full flex-col"
        [formGroup]="form"
        autocomplete="off"
        novalidate
        (ngSubmit)="onSubmit()">
        @if (!userMailAccount) {
          <app-searchable-select
            [label]="'user' | translate"
            [items]="userOptions"
            [(ngModel)]="selectedUserId"
            [ngModelOptions]="{ standalone: true }" />
        } @else {
          <mat-form-field>
            <mat-label>{{ 'user' | translate }}</mat-label>
            <input
              matInput
              id="name"
              formControlName="name"
              readonly
              required />
          </mat-form-field>
        }
        @if (roleOptions.length) {
          <app-searchable-select
            [label]="'role' | translate"
            [items]="roleOptions"
            [requireSelection]="true"
            [(ngModel)]="selectedRole"
            [ngModelOptions]="{ standalone: true }" />
        }
      </form>
    </div>
    <div class="flex w-full justify-end">
      <button
        mat-flat-button
        color="primary"
        [disabled]="isLoading || !formIsValid()"
        (click)="onSubmit()">
        <app-loading-button
          text="{{ 'save' | translate }}"
          [loading]="isLoading"></app-loading-button>
      </button>
    </div>
  }
</div>
